import Vue from 'vue';
import VueI18n from 'vue-i18n';
import es from './es';

Vue.use(VueI18n);

const i18n = new VueI18n({
    locale: 'es-ES',
    messages: {
        'es-ES': es
    }
});

export default i18n;
